const CM2IN_FACTOR = 0.3937

export const cm2In = (cm: number): number => cm * CM2IN_FACTOR
